module.exports = __webpack_public_path__ + "static/media/silverTop2D.b09ebf5e.webp";